export function getDateNumberForXDaysAgo(currentDate: number, numberOfDaysAgo: number) {
    return currentDate - numberOfDaysAgo * 24 * 60 * 60 * 1000;
}
